export default "__VITE_ASSET__B$rAmOun__"